import Phaser from 'phaser';

export class OpponentHand extends Phaser.GameObjects.Container {
  private tilebacks: Phaser.GameObjects.Graphics[] = [];
  private _tileCount: number = 0;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);
    scene.add.existing(this);
  }

  public setCount(count: number) {
    this._tileCount = count;
    this.tilebacks.forEach(t => t.destroy());
    this.tilebacks = [];
    
    for (let i = 0; i < count; i++) {
      const tileback = this.drawTileback();
      this.add(tileback);
      this.tilebacks.push(tileback);
    }
    
    this.layoutTiles();
  }

  public removeOne(animate: boolean = true) {
    if (this.tilebacks.length === 0) return;
    
    const tile = this.tilebacks.pop();
    this._tileCount--;
    
    if (tile && animate) {
      this.scene.tweens.add({
        targets: tile,
        y: tile.y + 100,
        alpha: 0,
        scale: 0.5,
        duration: 400,
        onComplete: () => {
          tile.destroy();
          this.layoutTiles();
        }
      });
    } else if (tile) {
      tile.destroy();
      this.layoutTiles();
    }
  }

  public drawTileback(): Phaser.GameObjects.Graphics {
    const g = this.scene.add.graphics();
    const w = 40;
    const h = 70;
    const r = 6;
    
    // Shadow
    g.fillStyle(0x000000, 0.4);
    g.fillRoundedRect(-w/2 + 2, -h/2 + 2, w, h, r);
    
    // BG
    g.fillStyle(0x004d00, 1);
    g.fillRoundedRect(-w/2, -h/2, w, h, r);
    
    // Border
    g.lineStyle(2, 0xd4af37, 1);
    g.strokeRoundedRect(-w/2, -h/2, w, h, r);
    
    // Pattern
    g.lineStyle(1, 0xd4af37, 0.5);
    g.strokeCircle(0, 0, 10);
    
    return g;
  }

  public dealAnimation(count: number, delay: number = 100) {
    this.setCount(count);
    
    this.tilebacks.forEach((tile, index) => {
      tile.setAlpha(0);
      tile.y -= 50;
      this.scene.tweens.add({
        targets: tile,
        y: 0,
        alpha: 1,
        duration: 400,
        delay: index * delay,
        ease: 'Back.easeOut'
      });
    });
  }

  private layoutTiles() {
    const spacing = 45;
    const totalWidth = (this.tilebacks.length - 1) * spacing;
    const startX = -totalWidth / 2;
    
    this.tilebacks.forEach((tile, index) => {
      this.scene.tweens.add({
        targets: tile,
        x: startX + index * spacing,
        duration: 300,
        ease: 'Power2'
      });
    });
  }
}
